import type { IOrganization } from "../../../contexts/organizations/organizationsContext";
import {
  refreshTokenAsync,
  signinRedirect,
  userManager,
} from "./AzureLoginHelper";
export type ExtraQueryParams = Record<string, string>;

export async function ReLoginUser() {
  const user = await refreshTokenAsync();
  if (!user) {
    const path = window.location.pathname + window.location.search;
    let query = window.location.search.substring(1);
    const urlParams = new URLSearchParams(query);
    let token = urlParams.get("token");
    await signinRedirect(path, {}, token);
  }
  return user;
}

export async function AzureLogin(setUserCallback: any, firstTimeUser: boolean) {
  const query = window.location.search.substring(1);
  const urlParams = new URLSearchParams(query);
  const extraQueryParams: ExtraQueryParams = {};

  const token = urlParams.get("token");
  const action = urlParams.get("action");

  if (action === "get-started") {
    for (const value of urlParams.keys()) {
      if (value !== "token") {
        extraQueryParams[value] = urlParams.get(value) || "";
      }
    }
  }

  let user = await userManager.getUser();

  if (user?.expired) {
    user = await refreshTokenAsync();
  }

  if (!user) {
    const path = window.location.pathname + window.location.search;
    await signinRedirect(path, extraQueryParams, token);
  } else {
    setUserCallback(user);
    const loginUri = window.location.pathname;

    const { profile } = user;
    // no other ways to update type for now. Need to refactor
    const profileOrganizations = profile?.organization as IOrganization[];

    if (
      firstTimeUser &&
      loginUri !== "/get-started" &&
      profile.firstSignIn &&
      profileOrganizations.length &&
      profileOrganizations[0].isOwner
    ) {
      window.history.replaceState({}, "");
      window.location.href = "/get-started";
      return;
    }

    if (loginUri === "/" || loginUri.includes("auth")) {
      window.location.href = "/safety-compliance/cache";
    }
  }
}
